import { actionCreator } from '@ardoq/rxbeach';
import { APIPresentationAssetAttributes, ArdoqId } from '@ardoq/api-types';
import { Maybe } from '@ardoq/common-helpers';

export type CreatePresentationPayload = {
  attributes: Partial<APIPresentationAssetAttributes>;
  folderId: Maybe<ArdoqId>;
};

export const updatePresentation = actionCreator<APIPresentationAssetAttributes>(
  '[presentations] UPDATE_PRESENTATION'
);

export const updatePresentationSucceeded =
  actionCreator<APIPresentationAssetAttributes>(
    '[presentations] UPDATE_PRESENTATION_SUCCEEDED'
  );

export const updatePresentationFailed =
  actionCreator<APIPresentationAssetAttributes>(
    '[presentations] UPDATE_PRESENTATION_FAILED'
  );

export const createPresentationAndOpenInPreview =
  actionCreator<CreatePresentationPayload>(
    '[presentations] CREATE_PRESENTATION_AND_OPEN_IN_PREVIEW'
  );

export type CreatePresentationAndOpenInEditorPayload = {
  name: string;
  folderId: ArdoqId | null;
  isOpeningPresentationEditorToAddSlideFromCurrentView: boolean;
};

export const createPresentationAndOpenInEditor =
  actionCreator<CreatePresentationAndOpenInEditorPayload>(
    '[presentations] CREATE_PRESENTATION_AND_OPEN_IN_EDITOR'
  );

export const notifyPresentationCreatedByUser =
  actionCreator<APIPresentationAssetAttributes>(
    '[presentations] NOTIFY_PRESENTATION_CREATED_BY_USER'
  );

export type OpenPresentationEditorPayload = {
  presentationId: ArdoqId;
  editingSlideId?: ArdoqId | null;
  isOpeningPresentationEditorToAddSlideFromCurrentView?: boolean;
  /** True when the caller means "take me into this presentation", false when it only means "reveal the sidebar". */
  shouldNavigateToPresentation: boolean;
};

export const openPresentationEditorRequested =
  actionCreator<OpenPresentationEditorPayload>(
    '[presentations] OPEN_PRESENTATION_EDITOR_REQUESTED'
  );
